
import { createClient } from '@supabase/supabase-js';

// Create a single supabase client for interacting with the database
export const supabase = createClient(
  'https://ensrbmzupjeiszivcwyv.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVuc3JibXp1cGplaXN6aXZjd3l2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ5MzIzOTIsImV4cCI6MjA2MDUwODM5Mn0.c8WBxBETDItX0i2KBNYMsOuSQPcgsJlyyWpCGjUg-3U',
  {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
      // Enable detection of auth tokens in URL
      detectSessionInUrl: true,
      flowType: 'pkce'
    }
  }
);

// Helper function to get the actual application URL (handles preview URLs and localhost)
export const getAppUrl = () => {
  // Get the current URL, but ensure we're not using localhost
  const currentUrl = window.location.origin;
  
  // If we're on localhost, we should use the actual production URL
  if (currentUrl.includes('localhost') || currentUrl.includes('127.0.0.1')) {
    // For development, you might have to manually replace this with your actual app URL
    console.log("Warning: Using localhost for auth redirects may cause issues.");
    
    // Use the production URL or a preview URL to avoid localhost issues
    const productionUrl = 'https://farmvault.newleaf.green';
    console.log("Using production URL for redirects:", productionUrl);
    return productionUrl;
  }
  
  console.log("Using current origin for redirects:", currentUrl);
  return currentUrl;
};

// Utility function to build a properly formatted redirect URL for password resets
export const buildRedirectUrl = (path = '/auth/reset-password') => {
  const baseUrl = getAppUrl();
  // Ensure we don't double-slash
  const formattedPath = path.startsWith('/') ? path : `/${path}`;
  const redirectUrl = `${baseUrl}${formattedPath}`;
  console.log("Built redirect URL:", redirectUrl);
  return redirectUrl;
}
